import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PublicTransitLayerEntityName } from '@api/entities/replancity_PublicTransitLine';
import { EntityServiceName } from '@api/enums/enums';
import EntitiesLoader from '../../../entities/EntitiesLoader/EntitiesLoader';
import EntityListRowForm from '../../../entities/entities-list/ui/EntitiesListRowForm/EntityListRowForm';
import CopyLineActionFabric from '../ListEntityActionCopyTo/CopyLineAction';
import TraceLineToNetworkFabric from '../../trace-line-to-network/ui/TraceLineToNetwork';

const TransitLinesList = () => {
    const entityName = PublicTransitLayerEntityName.LINES;
    const routesEntityName = PublicTransitLayerEntityName.ROUTES;
    const serviceName = EntityServiceName.PUBLIC_TRANSIT;
    const { t } = useTranslation();

    const actions = useMemo(
        () => [
            {
                label: t('transit-lines.copy-line-to-preset-btn-tooltip'),
                dialogTitle: t('transit-lines.trace-line-to-network-form-title'),
                dialogContentFabric: CopyLineActionFabric,
            },
            {
                label: t('transit-lines.trace-line-to-network-btn'),
                dialogTitle: t('transit-lines.trace-line-to-network-form-title'),
                dialogContentFabric: TraceLineToNetworkFabric,
            },
        ],
        [CopyLineActionFabric, TraceLineToNetworkFabric]
    );

    return (
        <EntitiesLoader
            entityName={entityName}
            layerEntityName={routesEntityName}
            serviceName={serviceName}
            form={EntityListRowForm}
            menuActions={actions}
        />
    );
};

export default TransitLinesList;
